import blogsData from './blogs.json';

export function getAllBlogs() {
  return [...blogsData].sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getBlogById(id) {
  return blogsData.find(blog => blog.id === id);
}

export function searchBlogs(query) {
  const q = query.toLowerCase();
  return blogsData.filter(blog =>
    blog.title.toLowerCase().includes(q) ||
    blog.excerpt.toLowerCase().includes(q) ||
    blog.author.toLowerCase().includes(q)
  );
}
